import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Banner from '../Component/CVReview/Banner'
import ReviewSection from '../Component/CVReview/ReviewSection'
import Footer from '../Component/NavBarFooter/Footer'
import RecentNews from '../Component/HomePage/RecentNews'

function CVReview() {
  return (
    <div>
        <NavBar/>
        <Banner/>
        <ReviewSection/>
        <Footer/>
    </div>
  )
}

export default CVReview